import React, {useContext, useState} from 'react';
import resultsContext from '../../Foundations/Contexts/ResultsContext';
import SvgIcon from '../Icons/SvgIcon';
import ErrorIcon from '../Icons/ErrorIcon';
import Button from '../Button';
import SelectVehicleTypeModal from '../Modals/SelectVehicleTypeModal';
import IVehicleType from '../../Foundations/Types/IVehicleType';
import searchFilterContext from '../../Foundations/Contexts/SearchFilterContext';
import {ISearchFilterItem} from '../../Foundations/Types/ISearchFilter';

const NoResultMessage: React.FC = () => {
    const {isLimited, limitedBy, availableVehicleTypes, setLimitedBy} = useContext(resultsContext);
    const {activeFilters} = useContext(searchFilterContext)
    const [showModal, setShowModal] = useState(false);
    const handleSearch = (val: IVehicleType): void => {
        setLimitedBy(val);
        setShowModal(false);
    }

    const hasActiveFilters: boolean = ((): boolean => {
        if (activeFilters === null) {
            return false;
        }

        return Object.keys(activeFilters)
            .some((key: string) => {
               let itemSelected = false;
               const items: ISearchFilterItem[] | undefined = activeFilters[key].items;

               if (
                   typeof items !== 'undefined'
               ) {
                   itemSelected = items.some((item) => item.selected === true)
               }

               return itemSelected;
            });
    })();

    return (
        <div className="bg-white shadow shadow-lg my-5 rounded border border-red border-l-8 border-t-0 border-r-0 border-b-0">
            <div className="flex items-center text-gray-700 py-2 pl-5 border border-red border-l-4 border-t-0 border-r-0 border-b-0 -ml-0.5">
                <SvgIcon className="inline-block mr-2 fill-red" height="18" width="18" viewBox="0 0 18 18">
                    <ErrorIcon />
                </SvgIcon>
                {
                    ((!isLimited && hasActiveFilters) || (isLimited && hasActiveFilters)) &&
                    <span>Your results returned no rates, try widening radius or use different filters.</span>
                }
                {
                    isLimited === false &&
                    hasActiveFilters === false &&
                    availableVehicleTypes.length === 0 &&
                    <span>No rates for any vehicles types are available</span>
                }
                {
                    availableVehicleTypes.length > 0 &&
                    isLimited === true &&
                    hasActiveFilters === false &&
                    (
                        <div className="w-full flex">
                            <div className="w-9/12">
                                {
                                    limitedBy !== null &&
                                    <strong>Car type "{limitedBy.label}" does not contain any results.</strong>
                                }
                                <p>Change your car type to continue your search at this location.</p>
                            </div>
                            <div className="w-3/12">
                               <Button className="ml-auto mr-5 font-bold" text="Change car type" onClick={() => setShowModal(true)} />
                            </div>
                            {
                                showModal &&
                                <SelectVehicleTypeModal
                                    hide={() => setShowModal(false)}
                                    onSubmit={handleSearch}
                                    availableVehicleTypes={availableVehicleTypes}
                                />
                            }
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default NoResultMessage;
